import IAuthService from "@/services/IAuthService";
import Vue from 'vue';
import TokenResult from "@/models/auth/TokenResult";
import LoginRequest from "@/models/auth/LoginRequest";

export default class AxiosAuthService implements IAuthService {

	login(loginRequest: LoginRequest): Promise<TokenResult> {
		return Vue.$axios.post<TokenResult>('auth/login', loginRequest)
			.then(res => res.data);
	}

	logout(): Promise<null> {
		return Vue.$axios.post<null>('auth/logout')
			.then(res => res.data);
	}

	refreshToken(tokenResult: TokenResult): Promise<TokenResult> {
		return Vue.$axios.post<TokenResult>('auth/refresh', {
			"refreshToken": tokenResult.refreshToken,
			"jwtToken": tokenResult.token,
		})
			.then(res => res.data);
	}

	resetPassword(email: string): Promise<null> {
		return Vue.$axios.post<null>('auth/reset-password', {
			email: email
		})
			.then(res => res.data);
	}

}
